import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function approveDeliveryDateChange(requestId) {
  const axios = axiosInstance().primoLab;

  const { data } = await axios.post(`/clinic-deliveries/approve-delivery-date-change/${requestId}`);
  return data;
}
